import colHtml from "../Col/col-html";
import { getPaddingString, styleToString, toRGBA } from "../parser/utils";
import { getRowBackgroundImageConfig } from "./Row";

export default (node, tree, contentWidth, preview = false) => {
    const {
      applyImageTo,
      applyBackgroundTo = "row",
      rowBackgroundColor,
      stackOnMobile,
    } = node.data;
    const bgImgStyleObject = getRowBackgroundImageConfig(node.data);
    const bgImgStyleStr = styleToString(bgImgStyleObject);
    const root = tree.root;
    let rowStyle = `display: flex;justify-content: ${root.data.contentAreaAlignment || "center"};`;
    let rowContentStyle = getPaddingString(node.data);
    
    rowContentStyle += `max-width:${contentWidth};`;
  
    if (applyBackgroundTo === "row") {
      rowStyle += `background-color: ${toRGBA(rowBackgroundColor)};`;
      rowContentStyle += `background-color: ${toRGBA(root.data.contentAreaBackgroundColor)};`;
    } else if (applyBackgroundTo === "content") {
      rowContentStyle += `background-color: ${toRGBA(
        rowBackgroundColor || root.data.contentAreaBackgroundColor
      )};`;
    }
  
    if (applyImageTo === "row") {
      rowStyle += bgImgStyleStr;
    } else if (applyImageTo === "content") {
      rowContentStyle += bgImgStyleStr;
    }
  
    let rowClass = ["rip-mm-row"];
    if (stackOnMobile === "on") {
      rowClass.push("rip-mm-row-stack");
    }
  
    return `
      <div id="${node.data.contentID || node.id}" class="${rowClass.join(" ")}" style="${rowStyle}">
        <div class="rip-mm-row-content" style="${rowContentStyle}">
          ${node.children
            .map((node) => {
              return colHtml(node, root, preview);
            })
            .join("")}
        </div>
      </div>
    `;
  };
